"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tutorialRoutes = void 0;
const tutorialActions_openapi_1 = require("./tutorialActions.openapi");
exports.tutorialRoutes = [
    {
        name: 'tutorial.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.list']
        }
    },
    {
        name: 'tutorial.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.create']
        }
    },
    {
        name: 'tutorial.scan',
        path: '/scan',
        method: 'POST',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.scan']
        }
    },
    {
        name: 'tutorial.generate',
        path: '/generate',
        method: 'POST'
    },
    {
        name: 'tutorial.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.get']
        }
    },
    {
        name: 'tutorial.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.update']
        }
    },
    {
        name: 'tutorial.section.content',
        path: '/:id/section/content',
        method: 'GET'
    },
    {
        name: 'tutorial.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.delete']
        }
    },
    {
        name: 'tutorial.participant.progress',
        path: '/:id/participant/progress',
        method: 'GET',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.participant.progress']
        }
    },
    {
        name: 'tutorial.participant.progress.save',
        path: '/:id/participant/progress',
        method: 'POST',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.participant.progress.save']
        }
    },
    {
        name: 'tutorial.participant.create',
        path: '/:id/participant',
        method: 'POST',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.participant.create']
        }
    },
    {
        name: 'tutorial.participant.delete',
        path: '/:id/participant/:uuid',
        method: 'DELETE',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.participant.delete']
        }
    },
    {
        name: 'tutorial.participant.list',
        path: '/:id/participant',
        method: 'GET',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.participant.list']
        }
    },
    {
        name: 'tutorial.statistics.list',
        path: '/:id/statistics',
        method: 'GET',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.statistics.list']
        }
    },
    {
        name: 'tutorial.category.list',
        path: ['/category', '/category/q/:q'],
        method: 'GET',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.category.list']
        },
        priority: 1,
    },
    {
        name: 'tutorial.category.create',
        path: ['/category'],
        method: 'POST',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.category.create']
        }
    },
    {
        name: 'tutorial.category.get',
        path: '/category/:id',
        method: 'GET',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.category.get']
        }
    },
    {
        name: 'tutorial.category.update',
        path: '/category/:id',
        method: 'PUT',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.category.update']
        }
    },
    {
        name: 'tutorial.category.delete',
        path: '/category/:id',
        method: 'DELETE',
        plugins: {
            openapi: tutorialActions_openapi_1.tutorialOpenApiDocs['tutorial.category.delete']
        }
    },
    {
        name: 'tutorial.participant.time',
        path: '/stats/:uuid/time',
        method: 'GET'
    }
];
